import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule]
})
export class ButtonComponent {
    @Input() public label: string;
    @Input() public size = 'md';
    @Input() public primary: boolean;
    @Input() public loading: boolean;
    @Input() public loadingText: string;
    @Input() public disabled: boolean;
    @Input() public notification: boolean;
    @Input() public notificationLabel: string;

    @Output() clicked = new EventEmitter();

    constructor() {}

    public click(): void {
        this.clicked.emit();
    }
}
